import { Component, OnInit, ViewChild } from '@angular/core';
import { UploadService } from '../api/upload.service';
import { SnackbarService } from '../../snackbar/service/snackbar.service';
import { FbxTableDto } from 'src/app/entity/fbxTableDto';
import { MatTableDataSource } from '@angular/material/table';
import { UserService } from 'src/app/user/user.service';
import { AuthService } from 'src/app/auth/api/auth.service';
import { TranslateService } from '@ngx-translate/core';
import { ConfirmationDialogComponent } from 'src/app/shared/confirmation-dialog/confirmation-dialog.component';
import { MatDialog } from '@angular/material/dialog';
import { saveAs as importedSaveAs } from "file-saver";
import { registerLocaleData } from '@angular/common';
import localeDe from '@angular/common/locales/de';
import { MatSort } from '@angular/material/sort';

@Component({
  selector: 'app-upload',
  templateUrl: './upload.component.html',
  styleUrls: ['./upload.component.scss'],
})
export class UploadComponent implements OnInit {
  @ViewChild(MatSort, { static: true }) sort: MatSort;
  constructor(
    private uploadService: UploadService,
    private snackbarService: SnackbarService,
    private userService: UserService,
    private authService: AuthService,
    private translate: TranslateService,
    public dialog: MatDialog
  ) { }

  private fileToUpload: File;
  private fbxFilesForLicence: MatTableDataSource<FbxTableDto>;
  private licenceId: number;
  private displayedColumns: string[] = ['filename', 'size', 'timeStamp', 'download', 'delete'];
  private uploading: boolean;

  private forbiddenSignsInNames: string[] = ['+', '&'];

  ngOnInit(): void {
    this.fbxFilesForLicence = new MatTableDataSource<FbxTableDto>();
    registerLocaleData(localeDe, 'de');

    this.userService
      .getUserLicenceById(this.authService.getUserId())
      .subscribe((res) => {
        if (res != null) {
          this.licenceId = res;

          this.getFileListForLicence();
        } else {
          console.log('Kein User gefunden oder User enthält keine licenceId');
        }
      });
  }

  private getFileListForLicence() {
    this.uploadService.getFbxFilesByLicenceId(this.licenceId).subscribe(
      (res) => {
        this.fbxFilesForLicence.data = res;
        console.log(res);
      },
      (error) => {
        this.snackbarService.open(
          'fbx.table.snackbar.errorWhileLoading',
          4,
          'failed'
        );
      }
    );

    if (this.fbxFilesForLicence.data != undefined) {
      this.fbxFilesForLicence.sort = this.sort;
    }
  }

  onClickBrowseButton(): void {
    document.querySelector('input').click();
  }

  handleFileInput(event: Event): void {
    const target = event.target as HTMLInputElement;
    const files = target.files;
    this.fileToUpload = files.item(0);
    event = null;

    this.uploadFileToActivity();
  }

  onFileDropped(event): void {
    this.fileToUpload = event[0];
    this.uploadFileToActivity();
  }

  validateFileSize(file: File): boolean {
    const currentFileSizeInDecimalMegaByte = file.size / 1000000;
    const maxFileSizeInDecimalMegaByte = 200;
    if (currentFileSizeInDecimalMegaByte < maxFileSizeInDecimalMegaByte) {
      return true;
    } else {
      this.snackbarService.open('upload.snackbar.errorFileToBig', 5, 'failed');
      return false;
    }
  }

  validateFilename(file: File): boolean {
    var valid: boolean = true;
    this.forbiddenSignsInNames.forEach(element => {
      if (file.name.includes(element)) {
        
        this.snackbarService.open(
          'upload.snackbar.signsInFilenameNotAllowed',
          5,
          'failed',
          '("' + element + '")'
        );

        valid = false;
      }
    })
    return valid;
  }

  validateFileExtension(file: File): boolean {
    const fileName = file.name;
    const fileExtension = fileName.substring(fileName.lastIndexOf('.') + 1);
    if (fileExtension.toLowerCase() === 'fbx') {
      return true;
    } else {
      this.snackbarService.open(
        'upload.snackbar.errorFileTypeNotSupported',
        5,
        'failed'
      );
      return false;
    }
  }

  validateForMaximumFiles(): boolean {
    if (this.fbxFilesForLicence.data.length < 5) {
      return true;
    } else {
      this.snackbarService.open(
        'upload.snackbar.errorTooMuchFiles',
        5,
        'failed'
      );
      return false;
    }
  }

  uploadFileToActivity() {
    if (
      this.validateFileExtension(this.fileToUpload) === true &&
      this.validateFileSize(this.fileToUpload) === true
    ) {
      if(this.validateFilename(this.fileToUpload)) {
        if (this.filenameAlreadyExist(this.fileToUpload.name)) {
          const confirmMessage = this.translate.instant('upload.filenameOccupied');
          const dialogRef = this.dialog.open(ConfirmationDialogComponent, {
            width: '30%',
            data: confirmMessage,
          });
  
          dialogRef.afterClosed().subscribe((result) => {
            if (result) {
              this.uploading = true;
  
              this.uploadService.updateFile(this.fileToUpload).subscribe(
                (res) => {
                  this.uploadSucceded();
                },
                (error) => {
                  this.uploadFailed(error);
                }
              );
            } else {
              this.fileToUpload = null;
            }
          });
        } else if (this.validateForMaximumFiles()) {
          this.uploading = true;
  
          this.uploadService.postFile(this.fileToUpload).subscribe(
            (res) => {
              this.uploadSucceded();
            },
            (error) => {
              this.uploadFailed(error);
            }
          );
        }
      }
    }
  }

  private filenameAlreadyExist(filename: string): boolean {
    for (const element of this.fbxFilesForLicence.data) {
      if (element.filename === filename) {
        return true;
      }
    }
    return false;
  }

  private uploadFailed(error: any) {
    console.log(error);
    this.uploading = false;
    this.snackbarService.open(
      'upload.snackbar.errorWhileUploading',
      5,
      'failed'
    );
  }

  private uploadSucceded() {
    this.uploading = false;
    this.snackbarService.open('upload.snackbar.successfulUpload', 5, 'success');
    this.getFileListForLicence();
  }

  download(filename: string) {
    this.uploadService.downloadFile(filename).subscribe(blob => {
      importedSaveAs(blob, filename);
    }
    )
  }

  delete(filename: string) {
    const confirmMessage = this.translate.instant('upload.fileDeleteConfirmation');
    const dialogRef = this.dialog.open(ConfirmationDialogComponent, {
      width: '30%',
      data: confirmMessage,
    });

    dialogRef.afterClosed().subscribe((result) => {
      if (result) {
        this.uploadService.deleteFile(filename, this.licenceId).subscribe((res) => {
          this.snackbarService.open('upload.snackbar.successfulDelete', 5, 'success');
          this.getFileListForLicence();
        }, (error) => {
          this.snackbarService.open('upload.snackbar.failedDelete', 5, 'failed');
        });
      }
    });
  }

}
